const getters = {
    isAuth(state) {
        return !!state.token
    }
}
export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js